module.exports = __webpack_public_path__ + "static/media/ross_face_split.2b49b471.png";